"use client";

import { useTranslations } from "next-intl";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../core/Select";
import { usePricingTableContext } from "./PricingTableContext";
import type { BillingCycle } from "./PricingControlsV3";

/**
 * Compact billing cycle dropdown that reads and writes to PricingTableContext.
 * Uses the same Select component as PricingControlsV3.
 */
export function BillingCycleToggle({ size = "lg" }: { size?: "md" | "lg" } = {}) {
  const t = useTranslations("PricingClientKeys.PricingCard");
  const { billingCycle, setBillingCycle } = usePricingTableContext();

  // Bump md height to 44px so it matches the pill TabList's md size (default Select md is 40px).
  const triggerClassName = size === "md" ? "tw-h-11" : undefined;

  return (
    <Select value={billingCycle} onValueChange={value => setBillingCycle(value as BillingCycle)}>
      <SelectTrigger variant='outline-new' size={size} overlayStyle className={triggerClassName}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='monthly' fontVariant='new'>
          {t("billing_cycle.monthly")}
        </SelectItem>
        <SelectItem value='yearly' fontVariant='new'>
          {t("billing_cycle.yearly")}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
